import { getTranslatedText } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import {
  Button,
  ButtonGroup,
  DisplayText,
  Modal,
  TextContainer,
  TextStyle
} from '@superops/ui-design-system';
import { isEmpty } from 'lodash';
import React, { useCallback, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { SrcInfoContainer } from '../Utils/style';

const HeaderElement = styled.div`
  margin: ${(props) => (props?.isNewLayout ? '0' : '0 2rem')};
  font-size: 24px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
`;

function SaveContainer(props) {
  const {
    intl,
    handleSave,
    actions,
    header,
    loading,
    cancelConfirmation,
    disableSave,
    disableSaveButton = false,
    actionName,
    actionIcon,
    hideSaveIcon,
    isNewLayout
  } = props;

  const [active, setActive] = useState(false);

  const handleChange = useCallback(() => setActive(!active), [active]);

  const modalRef = React.createRef();
  return (
    <>
      <SrcInfoContainers
        isNewLayout={isNewLayout}
        isTransparent={props?.removeSecondaryBtnBg}
        className="save-card MSP-Employee-Save-Card"
      >
        {!header ? (
          <div className="">
            {/* <TextField value={name} onChange={this.updateName.bind(this,'name')} /> */}
          </div>
        ) : (
          <>
            <HeaderElement isNewLayout>{header?.title}</HeaderElement>
          </>
        )}
        <div
          className="fx fx2 jend actr action-container"
          data-qa="saveContainerActions sam"
          superid="saveContainerActions sam"
        >
          <ButtonGroup spacing="loose">
            <div>
              {cancelConfirmation ? (
                <Button plainSecondary onClick={handleChange} ref={modalRef}>
                  <FormattedMessage id="common.cancel" />
                </Button>
              ) : (
                <Button plainSecondary onClick={actions?.back}>
                  <FormattedMessage id="common.cancel" />
                </Button>
              )}
            </div>
            {!disableSave && (
              <div id="saveContainer">
                <Button
                  primary
                  onClick={handleSave}
                  loading={loading}
                  id={props.id}
                  disabled={disableSaveButton}
                  icon={
                    hideSaveIcon ? (
                      undefined
                    ) : (
                      <SVGIcon name={actionIcon || 'Save'} color="#ffffff" />
                    )
                  }
                >
                  {!loading ? (
                    <span className="fx actr">
                      {isEmpty(actionName) ? (
                        <FormattedMessage id="common.save" />
                      ) : (
                        <TextStyle>{actionName}</TextStyle>
                      )}
                    </span>
                  ) : (
                    'Save'
                  )}
                </Button>
              </div>
            )}
          </ButtonGroup>
        </div>
      </SrcInfoContainers>
      <Modal
        activator={modalRef.current}
        open={active}
        onClose={handleChange}
        title={getTranslatedText(intl, 'ticket.newProject.cancel.goback')}
        primaryAction={{
          content: getTranslatedText(intl, 'ticket.newProject.cancel.yes'),
          onAction: actions?.back
        }}
        secondaryActions={[
          {
            content: getTranslatedText(intl, 'ticket.newProject.cancel.no'),
            onAction: handleChange
          }
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <DisplayText element="p" size="large">
              <FormattedMessage id="ticket.newProject.cancel.text" />
            </DisplayText>
          </TextContainer>
        </Modal.Section>
      </Modal>
    </>
  );
}

const SrcInfoContainers = styled(SrcInfoContainer)`
  background: ${(props) =>
    props.isNewLayout || props.isTransparent
      ? 'var(--sops-white-transparent-bg)'
      : '#f5f5fd'};
  // padding: 20px 0px 20px 20px;
  margin: 0;
`;

export default injectIntl(SaveContainer);
